import React from 'react';
import { useSelector } from 'react-redux';

import ValueCard from './ValueCard';
import ChartCard from './ChartCard';
import TextCard from './TextCard';

const ValueCards = [
  {
    title: 'Total Rich List Value (AUD)',
    color: 'text-purple-600',
  },
  {
    title: 'Average Wealth',
    color: 'text-green-600',
  },
  {
    title: 'Cut-off',
    color: 'text-pink-600',
  },
];

const CardsContainer = () => {
  const richLists = useSelector((state) => state.richLists);
  const { stats, activeList } = richLists;

  return (
    <div className="flex flex-col lg:flex-row mt-2">
      <div className="w-full lg:w-1/3 flex flex-col space-y-2 md:space-y-0 md:space-x-2 lg:space-x-0 lg:space-y-2 md:flex-row lg:flex-col lg:mr-1">
        {ValueCards.map((item, index) => {
          return (
            <ValueCard
              key={index}
              title={item.title}
              value={
                index === 0
                  ? stats.find((x) => x._id === activeList).totalvalue
                  : index === 1
                  ? stats.find((x) => x._id === activeList).average
                  : stats.find((x) => x._id === activeList).cutoff
              }
              change={
                index === 0
                  ? stats.find((x) => x._id === activeList).totalvaluechange
                  : index === 1
                  ? stats.find((x) => x._id === activeList).averagechange
                  : stats.find((x) => x._id === activeList).cutoffchange
              }
              color={item.color}
              length={
                index === 2 ? (
                  <span>
                    (List Length:{' '}
                    {stats.find((x) => x._id === activeList).length})
                  </span>
                ) : null
              }
            />
          );
        })}
      </div>
      <div className="mt-2 lg:mt-0 w-full lg:w-2/3 flex flex-col lg:ml-1">
        <ChartCard />
        <TextCard text={'Got a tip?'} linktext={'Get in touch'} link={'/note'} />
      </div>
    </div>
  );
};

export default CardsContainer;
